export default {
    title: "Base de Conocimiento",
    subtitle: "Gestiona bases de conocimiento y documentos para el agente AI",
    newKnowledgeBase: "Nueva Base de Conocimiento",
    searchPlaceholder: "Buscar por nombre o descripción...",
    typePlaceholder: "Filtrar por tipo",
    headers: {
        name: "Nombre",
        description: "Descripción",
        type: "Tipo",
        documentCount: "Documentos",
        createdAt: "Fecha de Creación",
        actions: "Acciones",
    },
    types: {
        general: "General",
        documents: "Documentos",
        routes: "Rutas",
        regulation: "Regulación",
        "company/account-specific": "Específico de Empresa/Cuenta",
        companyAccountSpecific: "Específico de Empresa/Cuenta",
    },
    actions: {
        view: "Ver",
        edit: "Editar",
        delete: "Eliminar",
        viewDocuments: "Ver Documentos",
    },
    form: {
        new: "Nueva Base de Conocimiento",
        edit: "Editar Base de Conocimiento",
        fields: {
            name: "Nombre",
            namePlaceholder: "Ingrese nombre de base de conocimiento",
            description: "Descripción",
            descriptionPlaceholder: "Ingrese descripción (opcional)",
            type: "Tipo",
            typePlaceholder: "Seleccione tipo",
        },
        documents: {
            title: "Documentos",
            uploadArea: "Arrastre archivos aquí o haga clic para seleccionar",
            supportedFormats: "Formatos soportados: PDF, DOCX, TXT, MD, JSON",
            selectFile: "Seleccionar Archivo",
            selectedFiles: "Archivos seleccionados:",
            noDocuments: "No hay documentos adjuntos",
            remove: "Eliminar",
            upload: "Subir",
        },
        save: "Guardar",
        cancel: "Cancelar",
        create: "Crear",
    },
    modal: {
        confirmDelete: "Confirmar Eliminación",
        confirmDeleteMessage: "¿Está seguro de que desea eliminar esta base de conocimiento? Esta acción no se puede deshacer.",
        cancel: "Cancelar",
        delete: "Eliminar",
    },
    loading: "Cargando...",
    noData: {
        title: "No hay bases de conocimiento disponibles",
        message: "No hay bases de conocimiento para mostrar",
        createFirst: "Crear la primera base de conocimiento",
    },
    detail: {
        title: "Detalles de Base de Conocimiento",
        backToList: "Volver a la Lista",
        documents: "Documentos",
        noDocuments: "No hay documentos en esta base de conocimiento",
        uploadDocument: "Subir Documento",
    },
    documentDetail: {
        tabs: {
            metadata: "Metadatos",
            content: "Contenido",
            chunks: "Chunks",
        },
        fields: {
            title: "Titulo",
            source: "Origen",
            category: "Categoria",
            topic: "Tema",
            tags: "Etiquetas",
            priority: "Prioridad",
            accessLevel: "Nivel de Acceso",
            language: "Idioma",
            version: "Version",
            retrievalCount: "Recuperaciones",
            chunkCount: "Chunks",
            embeddingQuality: "Calidad Embedding",
            createdAt: "Creado",
            updatedAt: "Actualizado",
            lastRetrieved: "Ultima Recuperacion",
        },
        content: {
            characters: "caracteres",
            words: "palabras",
            empty: "Sin contenido disponible",
        },
        chunks: {
            noChunks: "No hay chunks disponibles",
        },
        actions: {
            edit: "Editar",
            delete: "Eliminar",
            confirmDelete: "Confirmar Eliminacion",
            regenerate: "Re-generar Embeddings",
        },
        messages: {
            updateSuccess: "Documento actualizado con exito",
            updateError: "Error al actualizar el documento",
            deleteConfirm: "Esta seguro de que desea eliminar este documento? Esta accion no se puede deshacer.",
            regenerateSuccess: "Embeddings regenerados con exito",
            regenerateError: "Error al regenerar embeddings",
        },
    },
};
